import scheme from './scheme'
import methods from './methods'

export default {
  scheme,
  methods
}
